import { useMemo } from 'react'
import { ActionButton } from '../../../types/mf-execution.types'
import { getBottomPadding } from '../../../utils/sessionStorage'
import { EventNames } from '../../../types/misc.types'
import { trackEvent } from '../../../utils/appBridge'
import { InvestmentExistsButtonConfig, investmentExistsButtons } from '../../../utils/mf-execution/buttonsConfig'
import { ButtonsList } from './ButtonsList'
import { useToast } from '../../../state-management/contexts/ToastContext'
import { useMetaDataContext } from '../../../state-management/contexts/MetaDataContext'

const ERROR_EXECUTION_BAR_EVENT_ID = "We're adding this fund. Check back soon."

export const ErrorExecutionBar = ({ }) => {
  const { showToast } = useToast()
  const { isin, data } = useMetaDataContext()
  const fundIsin = isin ?? ''
  const fundName = data?.fundDetails?.fundName ?? ''

  const mapButtons = (buttons: InvestmentExistsButtonConfig[]): ActionButton[] => {
    return buttons.map((button) => {
      return {
        testLocator: button.testLocator,
        text: button.text,
        icon: button.icon,
        onClick: () => { },
        isPrimary: button.isPrimary || false,
        isDisabled: true
      }
    })
  }

  const buttons = useMemo(() => mapButtons(investmentExistsButtons), [])

  const handleNotifyMe = () => {
    showToast({ message: 'We\'ll notify you', duration: 3000 })
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName: 'MF_L2',
        buttonLabel: 'Notify me',
        eventId: ERROR_EXECUTION_BAR_EVENT_ID,
        fundIsin,
        fundName
      }
    })
  }

  return (
    <div
      style={{ paddingBottom: `${getBottomPadding() + 12 || 20}px` }}
      className='bg-white w-full pt-3 px-5 flex flex-col gap-[14px] border-t border-solid border-[#F0F4F7]'
    >
      <div className='text-[#6A6E6E] text-[13px] font-[400] text-center animate-fade-150'>
        Transactions for this fund aren't available on PowerUp yet.{' '}
        {/* <span
          test-locator='MFL2_CTA_LEARN_MORE'
          className='underline cursor-pointer'
          onClick={handleNotifyMe}
        >
          Notify Me
        </span> */}
      </div>
      <ButtonsList buttons={buttons} />
    </div>
  )
}

